export default class DateService {
  get_date_str(date) {
    return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate();
  }
}



// WEBPACK FOOTER //
// ./front/js/admin/services/date.service.js